module.exports = "/build/admin/images/apple-touch-icon-76x76.f1aaa8ba.png";